<template>
  <base-floating-card @close="close">
    <div id="add-to-do-modal">
      <Input
        class="scs-input"
        heading="To Do Title:"
        placeholder="Title"
        :error="errors.title"
        @scs-input="titleInput"
      />
      <div class="contact-scroller">
        <h5
          id="contact-scroller-heading"
          :class="errors.contacts ? 'error' : undefined"
        >
          Assign To:
        </h5>
        <div class="scroller">
          <item-tile
            v-for="contact in event.contacts"
            :key="contact.userId"
            :text="`${contact.given_name} ${contact.family_name}`"
            :selected="contactCheck(contact)"
            @primary-icon-clicked="selectContact(contact)"
          />
        </div>
      </div>
      <div id="add-to-do-button-wrapper">
        <Button
          class="scs-button"
          text="Close"
          :processing="processing"
          @click="close"
        />
        <Button
          class="scs-button"
          text="Save"
          :processing="processing"
          @click="save"
        />
      </div>
    </div>
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "../UI/FloatingCards/BaseFloatingCard.vue";
import Input from "../Elements/Input.vue";
import ItemTile from "../UI/ItemTile.vue";
import Button from "../UI/Button.vue";
export default {
  data() {
    return {
      processing: false,
      errors: {
        title: false,
        contacts: false,
      },
      todo: {
        tenantId: undefined,
        userId: undefined,
        dueDate: undefined,
        associatedEvents: [],
        associatedContacts: [],
        completed: false,
        title: undefined,
      },
    };
  },
  computed: {},
  methods: {
    titleInput(val) {
      this.todo.title = val;
    },
    close() {
      this.$emit("close");
    },
    async save() {
      if (!this.processing) {
        if (!this.todo.title) {
          this.errors.title = true;
        } else {
          this.errors.title = false;
        }
        if (this.todo.associatedContacts.length === 0) {
          this.errors.contacts = true;
        } else {
          this.errors.contacts = false;
        }
        if (!this.errors.title && !this.errors.contacts) {
          this.processing = true;
          this.todo.userId = "todo" + Date.now();
          await this.$store.dispatch("addEventToDo", {
            event: this.event,
            todo: this.todo,
          });
          this.processing = false;
          this.close();
        }
      }
    },
    selectContact(contact) {
      let index = this.todo.associatedContacts.indexOf(contact);
      if (index >= 0) {
        this.todo.associatedContacts.splice(index, 1);
      } else {
        this.todo.associatedContacts.push(contact);
      }
    },
    contactCheck(contact) {
      return this.todo.associatedContacts.includes(contact);
    },
  },
  created() {
    if (this.event) {
      this.todo.tenantId = this.event.tenantId;
      this.todo.associatedEvents = [this.event.userId];
    }
  },
  components: {
    BaseFloatingCard,
    Input,
    ItemTile,
    Button,
  },
  emits: ["close"],
  props: ["event", "contact"],
};
</script>
<style scoped>
@media screen {
  #add-to-do-modal {
    height: 425px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
  }

  .contact-scroller {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  #contact-scroller-heading {
    text-align: left;
  }

  .scroller {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    overflow: scroll;
  }

  #add-to-do-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .scs-button {
    margin: 0 10px;
  }

  .error {
    color: red;
  }
  @media (min-width: 800px) {
    #add-to-do-modal {
      width: 600px;
    }

    .scs-input {
      width: 275px;
    }
  }
}
</style>

<!-- {
 "tenantId": event.pathParameters.adminId,
 "userId": requestJSON.id,
 "dueDate": requestJSON.dueDate,
 "associatedEvents": requestJSON.associatedEvents,
 "associatedContacts": requestJSON.associatedContacts,
 "completed": requestJSON.completed,
 "title": requestJSON.title
}, -->
